<template>
  <div class="app-container" id="xmxjList">
    <div class="mycontainer" style="margin-bottom: 10px">
      <el-form
        ref="queryForm"
        :model="queryParams"
        :inline="true"
        label-width="120px"
      >
        <el-form-item label="统计年份" prop="jcnf">
          <el-date-picker
            ref="jcnf"
            v-model="queryParams.jcnf"
            type="year"
            :clearable="false"
            value-format="yyyy"
            placeholder="选择年"
            size="small"
            style="width: 185px"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="巡检月份" prop="jcyf">
          <el-select
            ref="jcyf"
            v-model="queryParams.jcyf"
            filterable
            multiple="true"
            collapse-tags
            size="small"
            style="width: 185px"
            class="filter-item"
            clearable
          >
            <el-option
              v-for="item in yfList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="所属部门" prop="bmbh">
          <el-select
            ref="bmbh"
            v-model="queryParams.bmbh"
            placeholder="所属部门"
            filterable
            size="small"
            style="width: 185px"
            class="filter-item"
            @change="handleChangeBm"
            multiple
            collapse-tags
          >
            <el-option
              v-for="item in bmList"
              :key="item.bmmc"
              :label="item.bmmc"
              :value="item.bmbh"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目状态" prop="xmzt">
          <el-select
            ref="xmzt"
            v-model="queryParams.xmzt"
            placeholder="项目状态"
            filterable
            multiple
            collapse-tags
            size="small"
            style="width: 185px"
            class="filter-item"
            @change="handleChangeHtzt"
          >
            <el-option
              v-for="item in htztList"
              :key="item.dictValue"
              :label="item.dictLabel"
              :value="item.dictValue"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="项目名称" prop="xmbh">
          <el-select
            ref="xmbh"
            v-model="queryParams.xmbh"
            placeholder="项目名称"
            filterable
            size="small"
            style="width: 185px"
            class="filter-item xmmc"
            clearable
            multiple
            collapse-tags
            @change="handleChangeXm"
            @visible-change="handleChangeXm"
          >
            <el-option
              v-for="item in xmList"
              :key="item.xmbh"
              :label="item.xmjc"
              :value="item.xmbh"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="区域总监" prop="qyzj">
          <el-select
            ref="qyzj"
            v-model="queryParams.qyzj"
            placeholder="区域总监"
            filterable
            size="small"
            style="width: 185px"
            class="filter-item"
            multiple
            collapse-tags
          >
            <el-option
              v-for="item in qyzjList"
              :key="item.ygbh"
              :label="item.xm"
              :value="item.ygbh"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="咨询总监" prop="zxzj">
          <el-select
            ref="zxzj"
            v-model="queryParams.zxzj"
            placeholder="咨询总监"
            clearable
            filterable
            size="small"
            style="width: 185px"
            class="filter-item"
            collapse-tags
            multiple
          >
            <el-option
              v-for="item in zxzjList"
              :key="item.ygbh"
              :label="item.xm"
              :value="item.ygbh"
            />
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="项目总监" prop="xmzj">
          <el-select
            ref="xmzj"
            v-model="queryParams.xmzj"
            placeholder="项目总监"
            filterable
            size="small"
            style="width: 185px"
            class="filter-item"
            multiple
            collapse-tags
          >
            <el-option
              v-for="item in xmzjList"
              :key="item.ygbh"
              :label="item.xm"
              :value="item.ygbh"
            />
          </el-select>
        </el-form-item> -->
        <el-form-item label="总部现场检结果" prop="znjg">
          <el-select
            ref="zbjg"
            v-model="queryParams.zbjg"
            filterable
            size="small"
            style="width: 185px"
            class="filter-item"
            clearable
          >
            <el-option
              v-for="item in jcjgList"
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="分总现场检结果" prop="fzjg">
          <el-select
            ref="fzjg"
            v-model="queryParams.fzjg"
            filterable
            size="small"
            style="width: 185px"
            class="filter-item"
            clearable
          >
            <el-option
              v-for="item in jcjgList"
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="系统线上检" prop="xtxsj">
          <el-select
            ref="zxtxsjbjg"
            v-model="queryParams.xtxsj"
            filterable
            size="small"
            style="width: 185px"
            class="filter-item"
            clearable
          >
            <el-option
              v-for="item in xtxsjList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item> -->
        <span style="margin-top: 4px; display: inline-block">
          <el-button
            type="primary"
            icon="el-icon-search"
            size="small"
            @click="handleQuery"
            >查询</el-button
          >
          <el-button
            type="primary"
            icon="el-icon-download"
            size="small"
            @click="handleExport"
            >导出</el-button
          >
        </span>
      </el-form>
    </div>
    <div>
      <el-table
        :max-height="height"
        v-loading="loading"
        row-key="reviewId"
        :data="xmxjList.list"
        fit
        highlight-current-row
        :header-cell-style="tableHeaderColor"
        :default-sort="{ prop: 'date', order: 'descending' }"
        tooltip-effect="dark"
      >
        <template slot="empty">
          <div class="nodata">
            <img src="@/img/nodata.png" alt="" width="160" />
            <div>暂无数据</div>
          </div>
        </template>
        <el-table-column
          label="所属部门"
          align="left"
          prop="bmmc"
          min-width="100px"
          :show-overflow-tooltip="true"
          fixed
        />
        <el-table-column
          label="项目名称"
          align="left"
          prop="xmmc"
          min-width="200px"
          :show-overflow-tooltip="true"
          fixed
        />
        <el-table-column
          label="项目阶段"
          align="left"
          prop="xmjd"
          min-width="80px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="区域总监"
          align="left"
          prop="qyzjname"
          min-width="80px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="咨询总监"
          align="left"
          prop="zxzjname"
          min-width="80px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="项目总监"
          align="left"
          prop="xmzjname"
          min-width="80px"
          :show-overflow-tooltip="true"
        />

        <el-table-column label="系统线上检" align="center">
          <el-table-column
            label="1月"
            align="center"
            prop="jan"
            min-width="70px"
          >
            <template slot="header">
              <el-tooltip
                class="item"
                effect="dark"
                placement="top"
                :open-delay="500"
              >
                <div slot="content">当月红色指标数</div>
                <div class="table_header">
                  1月&nbsp;
                  <img src="@/img/u285.svg" height="16" alt="" />
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            label="2月"
            align="center"
            prop="feb"
            min-width="70px"
          >
            <template slot="header">
              <el-tooltip
                class="item"
                effect="dark"
                placement="top"
                :open-delay="500"
              >
                <div slot="content">当月红色指标数</div>
                <div class="table_header">
                  2月&nbsp;
                  <img src="@/img/u285.svg" height="16" alt="" />
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            label="3月"
            align="center"
            prop="mar"
            min-width="70px"
          >
            <template slot="header">
              <el-tooltip
                class="item"
                effect="dark"
                placement="top"
                :open-delay="500"
              >
                <div slot="content">当月红色指标数</div>
                <div class="table_header">
                  3月&nbsp;
                  <img src="@/img/u285.svg" height="16" alt="" />
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            label="1季度关注类指标"
            align="center"
            prop="q1"
            min-width="100px"
          >
            <template slot-scope="scope">
              <span
                style="color: #036eb8; cursor: pointer"
                @click="handleToLineCheckDetail(scope.row)"
                >{{ scope.row.q1 ? scope.row.q1 : 0 }}</span
              >
            </template>
            <template slot="header">
              <el-tooltip
                class="item"
                effect="dark"
                placement="top"
                :open-delay="500"
              >
                <div slot="content">
                  季度内3次均为“红色”的指标，则定义为“关注类”指标
                </div>
                <div class="table_header">
                  1季度关注类指标&nbsp;
                  <img src="@/img/u285.svg" height="16" alt="" />
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            label="1季度关注类项目"
            align="center"
            prop="q1xm"
            min-width="100px"
          >
            <template slot="header">
              <el-tooltip
                class="item"
                effect="dark"
                placement="top"
                :open-delay="500"
              >
                <div slot="content">
                  季度内“关注类”指标数量达到标准以上的（具体为：一季度标准为4个（含）以上，二季度标准为3个（含）以上，三季度标准为3个（含）以上，四季度标准为4个（含）以上），定义为“关注类”项目。其他为“正常类”项目
                </div>
                <div class="table_header">
                  1季度关注类项目&nbsp;
                  <img src="@/img/u285.svg" height="16" alt="" />
                </div>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <span
                v-if="scope.row.q1 && scope.row.q1 >= jdgzlzbsList[0].dictLabel"
                style="color: #d9001b; cursor: pointer"
                @click="handleToLineCheckDetail(scope.row)"
                >关注类</span
              >
              <span
                v-else
                style="color: #70b603; cursor: pointer"
                @click="handleToLineCheckDetail(scope.row)"
                >正常类</span
              >
            </template>
          </el-table-column>
          <el-table-column
            label="4月"
            align="center"
            prop="apr"
            min-width="70px"
          >
            <template slot="header">
              <el-tooltip
                class="item"
                effect="dark"
                placement="top"
                :open-delay="500"
              >
                <div slot="content">当月红色指标数</div>
                <div class="table_header">
                  4月&nbsp;
                  <img src="@/img/u285.svg" height="16" alt="" />
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            label="5月"
            align="center"
            prop="may"
            min-width="70px"
          >
            <template slot="header">
              <el-tooltip
                class="item"
                effect="dark"
                placement="top"
                :open-delay="500"
              >
                <div slot="content">当月红色指标数</div>
                <div class="table_header">
                  5月&nbsp;
                  <img src="@/img/u285.svg" height="16" alt="" />
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            label="6月"
            align="center"
            prop="jun"
            min-width="70px"
          >
            <template slot="header">
              <el-tooltip
                class="item"
                effect="dark"
                placement="top"
                :open-delay="500"
              >
                <div slot="content">当月红色指标数</div>
                <div class="table_header">
                  6月&nbsp;
                  <img src="@/img/u285.svg" height="16" alt="" />
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            label="2季度关注类指标"
            align="center"
            prop="q2"
            min-width="100px"
          >
            <template slot-scope="scope">
              <span
                style="color: #036eb8; cursor: pointer"
                @click="handleToLineCheckDetail(scope.row)"
                >{{ scope.row.q2 ? scope.row.q2 : 0 }}</span
              >
            </template>
            <template slot="header">
              <el-tooltip
                class="item"
                effect="dark"
                placement="top"
                :open-delay="500"
              >
                <div slot="content">
                  季度内3次均为“红色”的指标，则定义为“关注类”指标
                </div>
                <div class="table_header">
                  2季度关注类指标&nbsp;
                  <img src="@/img/u285.svg" height="16" alt="" />
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            label="2季度关注类项目"
            align="center"
            prop="q2xm"
            min-width="100px"
          >
            <template slot="header">
              <el-tooltip
                class="item"
                effect="dark"
                placement="top"
                :open-delay="500"
              >
                <div slot="content">
                  季度内“关注类”指标数量达到标准以上的（具体为：一季度标准为4个（含）以上，二季度标准为3个（含）以上，三季度标准为3个（含）以上，四季度标准为4个（含）以上），定义为“关注类”项目。其他为“正常类”项目
                </div>
                <div class="table_header">
                  2季度关注类项目&nbsp;
                  <img src="@/img/u285.svg" height="16" alt="" />
                </div>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <span
                v-if="scope.row.q2 && scope.row.q2 >= jdgzlzbsList[1].dictLabel"
                style="color: #d9001b; cursor: pointer"
                @click="handleToLineCheckDetail(scope.row)"
                >关注类</span
              >
              <span
                v-else
                style="color: #70b603; cursor: pointer"
                @click="handleToLineCheckDetail(scope.row)"
                >正常类</span
              >
            </template>
          </el-table-column>
          <el-table-column
            label="7月"
            align="center"
            prop="jul"
            min-width="70px"
          >
            <template slot="header">
              <el-tooltip
                class="item"
                effect="dark"
                placement="top"
                :open-delay="500"
              >
                <div slot="content">当月红色指标数</div>
                <div class="table_header">
                  7月&nbsp;
                  <img src="@/img/u285.svg" height="16" alt="" />
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            label="8月"
            align="center"
            prop="aug"
            min-width="70px"
          >
            <template slot="header">
              <el-tooltip
                class="item"
                effect="dark"
                placement="top"
                :open-delay="500"
              >
                <div slot="content">当月红色指标数</div>
                <div class="table_header">
                  8月&nbsp;
                  <img src="@/img/u285.svg" height="16" alt="" />
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            label="9月"
            align="center"
            prop="sept"
            min-width="70px"
          >
            <template slot="header">
              <el-tooltip
                class="item"
                effect="dark"
                placement="top"
                :open-delay="500"
              >
                <div slot="content">当月红色指标数</div>
                <div class="table_header">
                  9月&nbsp;
                  <img src="@/img/u285.svg" height="16" alt="" />
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            label="3季度关注类指标"
            align="center"
            prop="q3"
            min-width="100px"
          >
            <template slot-scope="scope">
              <span
                style="color: #036eb8; cursor: pointer"
                @click="handleToLineCheckDetail(scope.row)"
                >{{ scope.row.q3 ? scope.row.q3 : 0 }}</span
              >
            </template>
            <template slot="header">
              <el-tooltip
                class="item"
                effect="dark"
                placement="top"
                :open-delay="500"
              >
                <div slot="content">
                  季度内3次均为“红色”的指标，则定义为“关注类”指标
                </div>
                <div class="table_header">
                  3季度关注类指标&nbsp;
                  <img src="@/img/u285.svg" height="16" alt="" />
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            label="3季度关注类项目"
            align="center"
            prop="q3xm"
            min-width="100px"
          >
            <template slot="header">
              <el-tooltip
                class="item"
                effect="dark"
                placement="top"
                :open-delay="500"
              >
                <div slot="content">
                  季度内“关注类”指标数量达到标准以上的（具体为：一季度标准为4个（含）以上，二季度标准为3个（含）以上，三季度标准为3个（含）以上，四季度标准为4个（含）以上），定义为“关注类”项目。其他为“正常类”项目
                </div>
                <div class="table_header">
                  3季度关注类项目&nbsp;
                  <img src="@/img/u285.svg" height="16" alt="" />
                </div>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <span
                v-if="scope.row.q3 && scope.row.q3 >= jdgzlzbsList[2].dictLabel"
                style="color: #d9001b; cursor: pointer"
                @click="handleToLineCheckDetail(scope.row)"
                >关注类</span
              >
              <span
                v-else
                style="color: #70b603; cursor: pointer"
                @click="handleToLineCheckDetail(scope.row)"
                >正常类</span
              >
            </template>
          </el-table-column>
          <el-table-column
            label="10月"
            align="center"
            prop="oct"
            min-width="70px"
          >
            <template slot="header">
              <el-tooltip
                class="item"
                effect="dark"
                placement="top"
                :open-delay="500"
              >
                <div slot="content">当月红色指标数</div>
                <div class="table_header">
                  10月&nbsp;
                  <img src="@/img/u285.svg" height="16" alt="" />
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            label="11月"
            align="center"
            prop="nov"
            min-width="70px"
          >
            <template slot="header">
              <el-tooltip
                class="item"
                effect="dark"
                placement="top"
                :open-delay="500"
              >
                <div slot="content">当月红色指标数</div>
                <div class="table_header">
                  11月&nbsp;
                  <img src="@/img/u285.svg" height="16" alt="" />
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            label="12月"
            align="center"
            prop="dec"
            min-width="70px"
          >
            <template slot="header">
              <el-tooltip
                class="item"
                effect="dark"
                placement="top"
                :open-delay="500"
              >
                <div slot="content">当月红色指标数</div>
                <div class="table_header">
                  12月&nbsp;
                  <img src="@/img/u285.svg" height="16" alt="" />
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            label="4季度关注类指标"
            align="center"
            prop="q4"
            min-width="100px"
          >
            <template slot-scope="scope">
              <span
                style="color: #036eb8; cursor: pointer"
                @click="handleToLineCheckDetail(scope.row)"
                >{{ scope.row.q4 ? scope.row.q4 : 0 }}</span
              >
            </template>
            <template slot="header">
              <el-tooltip
                class="item"
                effect="dark"
                placement="top"
                :open-delay="500"
              >
                <div slot="content">
                  季度内3次均为“红色”的指标，则定义为“关注类”指标
                </div>
                <div class="table_header">
                  4季度关注类指标&nbsp;
                  <img src="@/img/u285.svg" height="16" alt="" />
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            label="4季度关注类项目"
            align="center"
            prop="q4xm"
            min-width="100px"
          >
            <template slot="header">
              <el-tooltip
                class="item"
                effect="dark"
                placement="top"
                :open-delay="500"
              >
                <div slot="content">
                  季度内“关注类”指标数量达到标准以上的（具体为：一季度标准为4个（含）以上，二季度标准为3个（含）以上，三季度标准为3个（含）以上，四季度标准为4个（含）以上），定义为“关注类”项目。其他为“正常类”项目
                </div>
                <div class="table_header">
                  4季度关注类项目&nbsp;
                  <img src="@/img/u285.svg" height="16" alt="" />
                </div>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <span
                v-if="scope.row.q4 && scope.row.q4 >= jdgzlzbsList[3].dictLabel"
                style="color: #d9001b; cursor: pointer"
                @click="handleToLineCheckDetail(scope.row)"
                >关注类</span
              >
              <span
                v-else
                style="color: #70b603; cursor: pointer"
                @click="handleToLineCheckDetail(scope.row)"
                >正常类</span
              >
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="总部现场检" align="center">
          <el-table-column
            label="首次检"
            align="left"
            prop="zb1"
            min-width="80px"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <div
                v-if="scope.row.zbjg1 == '高'"
                style="
                  background: #d9001b;
                  cursor: pointer;
                  color: #fff;
                  text-align: center;
                  border-radius: 5px;
                "
                @click="handleToZbCheckDetail(scope.row)"
              >
                高
              </div>
              <div
                v-else-if="scope.row.zbjg1 == '中'"
                style="
                  background: #f59a23;
                  cursor: pointer;
                  color: #fff;
                  text-align: center;
                  border-radius: 5px;
                "
                @click="handleToZbCheckDetail(scope.row)"
              >
                中
              </div>
              <div
                v-else-if="scope.row.zbjg1 == '低'"
                style="
                  background: #70b603;
                  cursor: pointer;
                  color: #fff;
                  text-align: center;
                  border-radius: 5px;
                "
                @click="handleToZbCheckDetail(scope.row)"
              >
                低
              </div>
              <div
                v-else
                style="color: #036eb8; cursor: pointer"
                @click="handleToEdit(scope.row, 1)"
                v-show="
                  scope.row.author &&
                  (scope.row.author.manage == 1 ||
                    scope.row.author.xzcheck == 1)
                "
              >
                编辑
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="二次检"
            align="left"
            prop="zb2"
            min-width="80px"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <div
                v-if="scope.row.zbjg2 == '高'"
                style="
                  background: #d9001b;
                  cursor: pointer;
                  color: #fff;
                  text-align: center;
                  border-radius: 5px;
                "
                @click="handleToZbCheckDetail(scope.row)"
              >
                高
              </div>
              <div
                v-else-if="scope.row.zbjg2 == '中'"
                style="
                  background: #f59a23;
                  cursor: pointer;
                  color: #fff;
                  text-align: center;
                  border-radius: 5px;
                "
                @click="handleToZbCheckDetail(scope.row)"
              >
                中
              </div>
              <div
                v-else-if="scope.row.zbjg2 == '低'"
                style="
                  background: #70b603;
                  cursor: pointer;
                  color: #fff;
                  text-align: center;
                  border-radius: 5px;
                "
                @click="handleToZbCheckDetail(scope.row)"
              >
                低
              </div>
              <div
                v-else
                style="color: #036eb8; cursor: pointer"
                @click="handleToEdit(scope.row, 2)"
                v-show="
                  scope.row.author &&
                  (scope.row.author.manage == 1 ||
                    scope.row.author.xzcheck == 1)
                "
              >
                编辑
              </div>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="分总现场检" align="center">
          <el-table-column
            label="首次检"
            align="left"
            prop="fz1"
            min-width="80px"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <div
                v-if="scope.row.fzjg1 == '高'"
                style="
                  background: #d9001b;
                  cursor: pointer;
                  color: #fff;
                  text-align: center;
                  border-radius: 5px;
                "
                @click="handleToFzCheckDetail(scope.row, 1)"
              >
                高
              </div>
              <div
                v-else-if="scope.row.fzjg1 == '中'"
                style="
                  background: #f59a23;
                  cursor: pointer;
                  color: #fff;
                  text-align: center;
                  border-radius: 5px;
                "
                @click="handleToFzCheckDetail(scope.row, 1)"
              >
                中
              </div>
              <div
                v-else-if="scope.row.fzjg1 == '低'"
                style="
                  background: #70b603;
                  cursor: pointer;
                  color: #fff;
                  text-align: center;
                  border-radius: 5px;
                "
                @click="handleToFzCheckDetail(scope.row, 1)"
              >
                低
              </div>
              <span
                v-else
                style="color: #036eb8; cursor: pointer"
                @click="handleToFzCheckDetail(scope.row, 1)"
                v-show="
                  scope.row.author &&
                  (scope.row.author.manage == 1 || scope.row.author.fz == 1)
                "
              >
                编辑
              </span>
            </template>
          </el-table-column>
          <el-table-column
            label="二次检"
            align="left"
            prop="fz2"
            min-width="80px"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <div
                v-if="scope.row.fzjg2 == '高'"
                style="
                  background: #d9001b;
                  cursor: pointer;
                  color: #fff;
                  text-align: center;
                  border-radius: 5px;
                "
                @click="handleToFzCheckDetail(scope.row, 2)"
              >
                高
              </div>
              <div
                v-else-if="scope.row.fzjg2 == '中'"
                style="
                  background: #f59a23;
                  cursor: pointer;
                  color: #fff;
                  text-align: center;
                  border-radius: 5px;
                "
                @click="handleToFzCheckDetail(scope.row, 2)"
              >
                中
              </div>
              <div
                v-else-if="scope.row.fzjg2 == '低'"
                style="
                  background: #70b603;
                  cursor: pointer;
                  color: #fff;
                  text-align: center;
                  border-radius: 5px;
                "
                @click="handleToFzCheckDetail(scope.row, 2)"
              >
                低
              </div>
              <div
                v-else
                style="color: #036eb8; cursor: pointer"
                @click="handleToFzCheckDetail(scope.row, 2)"
                v-show="
                  scope.row.author &&
                  (scope.row.author.manage == 1 || scope.row.author.fz == 1)
                "
              >
                编辑
              </div>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
      <pagination
        v-show="xmxjList.total > 0"
        :total="xmxjList.total"
        :page.sync="queryParams.page"
        :limit.sync="queryParams.pageSize"
        @pagination="getList"
      />

      <el-dialog
        title="编辑"
        :visible.sync="editDialog"
        width="900px"
        :closeOnClickModal="false"
        v-if="editDialog"
        class="editDialog"
      >
        <div>
          <el-form
            ref="editForm"
            label-width="120px"
            :model="editForm"
            :hide-required-asterisk="false"
            :rules="editRules"
            v-loading.fullscreen.lock="fullscreenLoading"
          >
            <el-form-item label="项目名称：" prop="xmmc">
              <el-input
                show-word-limit
                placeholder=""
                v-model="editForm.xmmc"
                size="small"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item label="巡检时间：" prop="xjrq">
              <el-date-picker
                v-model="editForm.xjrq"
                style="width: 100%"
                type="date"
                placeholder="请选择"
                size="small"
                :clearable="false"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="风险等级：" prop="xjjg">
              <el-select
                ref="status"
                v-model="editForm.xjjg"
                placeholder="风险等级"
                filterable
                size="small"
                style="width: 100%"
                class="filter-item"
              >
                <el-option
                  v-for="item in fxdjList"
                  :key="item"
                  :label="item"
                  :value="item"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="巡检组长：" prop="xjzz">
              <div class="treeselect">
                <treeselect
                  v-model="editForm.xjzz"
                  placeholder="请选择员工"
                  :options="deptUser"
                  :disable-branch-nodes="true"
                  :show-count="true"
                  value-consists-of="LEAF_PRIORITY"
                  no-results-text="未搜到任何结果"
                  :clear-on-select="true"
                  :normalizer="normalizer"
                  style="width: 100%"
                  size="small"
                  :multiple="true"
                />
              </div>
            </el-form-item>
            <el-form-item label="巡检成员：" prop="xjcy">
              <div class="treeselect">
                <treeselect
                  v-model="editForm.xjcy"
                  placeholder="请选择员工"
                  :options="deptUser"
                  :disable-branch-nodes="true"
                  :show-count="true"
                  value-consists-of="LEAF_PRIORITY"
                  no-results-text="未搜到任何结果"
                  :clear-on-select="true"
                  :normalizer="normalizer"
                  style="width: 100%"
                  size="small"
                  :multiple="true"
                />
              </div>
            </el-form-item>
            <el-form-item label="分公司人员：" prop="fgscy">
              <div class="treeselect">
                <treeselect
                  v-model="editForm.fgscy"
                  placeholder="请选择员工"
                  :options="deptUser"
                  :disable-branch-nodes="true"
                  :show-count="true"
                  value-consists-of="LEAF_PRIORITY"
                  no-results-text="未搜到任何结果"
                  :clear-on-select="true"
                  :normalizer="normalizer"
                  style="width: 100%"
                  size="small"
                  :multiple="true"
                />
              </div>
            </el-form-item>
            <el-form-item label="拜访对象：" prop="bfdx" class="require-item">
              <div class="bfdx">
                <div>
                  <span>董事长/理事长：</span>
                  <el-input
                    show-word-limit
                    placeholder=""
                    v-model="editForm.bfdx.dsz"
                    style="width: 130px"
                    size="small"
                    @input="$forceUpdate()"
                  ></el-input>
                </div>
                <div>
                  <span>行长/主任：</span>
                  <el-input
                    show-word-limit
                    placeholder=""
                    v-model="editForm.bfdx.hz"
                    style="width: 130px"
                    size="small"
                    @input="$forceUpdate()"
                  ></el-input>
                </div>
                <div>
                  <span>分管领导：</span>
                  <el-input
                    show-word-limit
                    placeholder=""
                    v-model="editForm.bfdx.fgld"
                    size="small"
                    style="width: 130px"
                    @input="$forceUpdate()"
                  ></el-input>
                </div>
                <div>
                  <span>牵头部门负责人：</span>
                  <el-input
                    show-word-limit
                    placeholder=""
                    v-model="editForm.bfdx.qtbmfzr"
                    size="small"
                    style="width: 130px"
                    @input="$forceUpdate()"
                  ></el-input>
                </div>
                <div>
                  <span>其他高管：</span>
                  <el-input
                    show-word-limit
                    placeholder=""
                    v-model="editForm.bfdx.qtgg"
                    style="width: 130px"
                    size="small"
                    @input="$forceUpdate()"
                  ></el-input>
                </div>
              </div>
            </el-form-item>

            <el-form-item
              label="选择附件："
              prop="fileIds"
              class="require-item"
            >
              <el-row>
                <el-col :span="4">
                  <el-upload
                    action="#"
                    class="upload-demo"
                    ref="upload"
                    :headers="headers"
                    :on-change="handleChange"
                    :on-exceed="handleExceed"
                    :file-list="fileList"
                    :auto-upload="false"
                    multiple
                    :limit="5"
                  >
                    <el-button type="primary" icon="el-icon-upload" plain
                      >选择附件</el-button
                    >
                  </el-upload>
                </el-col>
                <el-col :span="20" style="line-height: 40px">
                  <div>
                    (单个文件不能超过10M，支持word、excel、pdf、zip、rar的格式，总数不能超过5个)
                  </div>
                </el-col>
              </el-row>
            </el-form-item>
          </el-form>
        </div>
        <div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="editDialog = false" size="smalll">
              取消
            </el-button>
            <el-button type="primary" size="smalll" @click="handleEditResult()">
              确定
            </el-button>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  getDict,
  getPersonAdviceList,
  getXmxxList,
  getXmzjList,
} from "@/api/common";
import { getBmxxList } from "@/api/itWeekly.js";
import { getAreaDirectorList } from "@/api/xmReview.js";
import {
  exportInspecList,
  getDictData,
  getInspecList,
  saveZbInspect,
  uploadFile,
} from "@/api/xmcheck.js";
import Pagination from "@/components/Pagination";
import { addExportFileDate } from "@/utils/utils";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import moment from "moment";
import "moment/locale/zh-cn";
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["deptUser", "user"]),
  },
  components: { Pagination, Treeselect },
  data() {
    return {
      pickerOptions: {
        disabledDate: (time) => {
          let oldDate = new Date("2023-12-31T12:00:00.000Z");
          let oneYear = new Date(oldDate).getTime();
          return time.getTime() < oneYear;
        },
      },
      loading: false,
      height: 800,
      ids: [], // 选中数组
      single: true, // 非单个禁用
      multiple: true, // 非多个禁用
      showSearch: true, // 显示搜索条件
      isManage: 0, // 是否管理员
      xmxjList: {
        list: [],
        total: 0,
      }, // 表格数据
      xmxxOptions: [],
      resultOptions: [],
      title: "", // 弹出层标题
      open: false, // 是否显示弹出层
      queryParams: {
        jcnf: moment().format("YYYY"),
        bmbh: [],
        xmbh: [],
        xmmc: [],
        xmzt: ["1"],
        qyzj: [],
        zxzj: [],
        xmzj: [],
        zbjg: "",
        fzjg: "",
        xtxsj: "",
        jcyf: [],
        page: 1,
        pageSize: 10,
      },
      params: {
        type: 2, //说明：类型1 总部-分公司 2分公司-总部
        xmlx: "DS", //说明：合同类型，多个,隔开，如DS,SW,SD,TS
        range: 0, //说明：数据范围 1-角色数据权限 0-全部
        xmzt: null, //合同状态，多个,隔开，如1,3
      },
      //   新增编辑表单提交参数
      form: {}, // 表单参数
      rules: {
        // 表单校验
      },
      bmList: [],
      htztList: [],
      xmList: [],
      qyzjList: [],
      zxzjList: [],
      xmzjList: [],
      jdgzlzbsList: [],
      editDialog: false,
      fullscreenLoading: false,
      editForm: {
        bfdx: {},
      },
      fileList: [],
      headers: {
        "x-token": localStorage.getItem("token"),
      },
      normalizer(node) {
        return {
          children: node.users,
        };
      },
      editRules: {
        xjrq: [
          { required: true, message: "巡检日期不能为空", trigger: "change" },
        ],
        xjjg: [
          { required: true, message: "风险等级不能为空", trigger: "change" },
        ],
        xjzz: [
          { required: true, message: "巡检组长不能为空", trigger: "change" },
        ],
        xjcy: [
          { required: true, message: "巡检成员不能为空", trigger: "change" },
        ],
        fgscy: [
          { required: true, message: "分公司成员不能为空", trigger: "change" },
        ],
      },
      fxdjList: ["高", "中", "低"],
      jcjgList: ["高", "中", "低", "已检", "未检"],
      yfList: [
        {
          label: "一月",
          value: "01",
        },
        {
          label: "二月",
          value: "02",
        },
        {
          label: "三月",
          value: "03",
        },
        {
          label: "四月",
          value: "04",
        },
        {
          label: "五月",
          value: "05",
        },
        {
          label: "六月",
          value: "06",
        },

        {
          label: "七月",
          value: "07",
        },
        {
          label: "八月",
          value: "08",
        },
        {
          label: "九月",
          value: "09",
        },
        {
          label: "十月",
          value: "10",
        },
        {
          label: "十一月",
          value: "11",
        },
        {
          label: "十二月",
          value: "12",
        },
      ],
      xtxsjList: [
        {
          label: "正常类",
          value: "正常类",
        },
        {
          label: "关注类",
          value: "关注类",
        },
      ],
    };
  },
  created() {
    if (!this.user.xm) {
      this.$store.dispatch("common/fetchUserInfoAction");
    }
    if (!this.deptUser || this.deptUser.length == 0) {
      this.$store.dispatch("common/getDeptUser");
    }
    getDictData("xmcheck_review_result", "1").then((res) => {
      if (res.code === 0) {
        this.resultOptions = res.data;
      }
    });
    getBmxxList("2", "1").then((res) => {
      if (res.code == 0) {
        this.bmList = res.data;
        // this.queryParams.bmbh = [this.bmList[0].bmbh];
      }
    });

    getDict("xmgl_xmzt", "2").then((res) => {
      if (res.code == 0) {
        this.htztList = res.data;
        // if (localStorage.getItem("fzj_params")) {
        // } else {
        //   this.queryParams.xmzt = [res.data[0].dictValue];
        // }
        this.getXmxxListFun();
      }
    });
    getDict("pmp_xmxj_jdgzlzbs").then((res) => {
      if (res.code == 0) {
        this.jdgzlzbsList = res.data;
      }
    });
    this.getList();
    this.getXmxxListFun();
    this.getQyzjListFuc();
    this.getXmzjListFuc();
    this.getZxzjListFuc();
  },
  mounted() {
    const docH = document.documentElement.clientHeight;
    const mycontainerH = document.querySelector(".mycontainer").clientHeight;
    this.height = docH - mycontainerH - 80;
  },
  methods: {
    /** 查询模板列表 */
    getList() {
      this.loading = true;
      const {
        xmbh,
        jcnf,
        bmbh,
        xmzt,
        qyzj,
        zxzj,
        xmzj,
        page,
        fzjg,
        zbjg,
        xtxsj,
        jcyf,
        pageSize,
      } = this.queryParams;
      const data = {
        xmbh: xmbh.join(","),
        jcnf,
        bmbh: bmbh.join(","),
        xmzt: xmzt.join(","),
        qyzj: qyzj.join(","),
        zxzj: zxzj.join(","),
        xmzj: xmzj.join(","),
        xtxsj,
        jcyf: jcyf.join(","),
        page,
        pageSize,
        fzjg,
        zbjg,
      };

      getInspecList(data).then((response) => {
        this.loading = false;

        if (response.code === 0) {
          this.xmxjList.list = response.data;
          this.xmxjList.total = response.count;
        } else {
          this.$message({
            showClose: true,
            message: response.msg,
            type: "error",
            duration: 2000,
            center: true,
          });
        }
      });
    },
    getXmxxListFun() {
      getXmxxList({
        xmlx: "DS",
        type: "2",
        range: "1",
        xmzt: this.queryParams.xmzt.join(","),
        bmbh: this.queryParams.bmbh.join(","),
      }).then((res) => {
        if (res.code == 0) {
          this.xmList = res.data;
          // this.queryParams.xmbh = [this.xmList[0].xmbh];
          this.queryParams.xmbh = [];
          // this.getList();
        }
      });
    },
    getQyzjListFuc() {
      getAreaDirectorList({ bmbh: this.queryParams.bmbh.join(",") }).then(
        (res) => {
          if (res.code == 0) {
            this.qyzjList = res.data;
          }
        }
      );
    },
    getZxzjListFuc() {
      getPersonAdviceList({ bmbh: this.queryParams.bmbh.join(",") }).then(
        (res3) => {
          if (res3.code == 0) {
            this.zxzjList = res3.data;
          }
        }
      );
    },
    getXmzjListFuc() {
      getXmzjList({ bmbh: this.queryParams.bmbh.join(",") }).then((res3) => {
        if (res3.code == 0) {
          this.xmzjList = res3.data;
        }
      });
    },

    handleChangeBm(i) {
      this.queryParams.bmbh = i;
      this.queryParams.bmmc = i;
      this.getXmxxListFun();
      this.getQyzjListFuc();
      this.getXmzjListFuc();
      this.getZxzjListFuc();
    },
    //导出
    handleExport() {
      const {
        xmbh,
        jcnf,
        bmbh,
        xmzt,
        qyzj,
        zxzj,
        fzjg,
        zbjg,
        xmzj,
        xtxsj,
        jcyf,
      } = this.queryParams;
      const data = {
        xmbh: xmbh.join(","),
        jcnf,
        bmbh: bmbh.join(","),
        xmzt: xmzt.join(","),
        qyzj: qyzj.join(","),
        zxzj: zxzj.join(","),
        xmzj: xmzj.join(","),
        fzjg,
        zbjg,
        xtxsj,
        jcyf: jcyf.join(","),
      };
      exportInspecList(data).then((res) => {
        if (res.code === 0) {
          let fileName = res.msg.substr(
            res.msg.indexOf("_") + 1,
            res.msg.length
          );
          fileName = addExportFileDate(fileName);

          const filePath = res.msg;
          const url =
            window.g.apiUrl +
            "system/downloadFile?fileName=" +
            fileName +
            "&filePath=" +
            filePath;
          // 组装a标签
          const elink = document.createElement("a");
          // 设置下载文件名
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = url;
          document.body.appendChild(elink);
          elink.click();
          document.body.removeChild(elink);
        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: "error",
          });
        }
      });
    },

    handleQuery() {
      this.getList();
    },

    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f2f2f2;";
      }
    },
    handleToLineCheckDetail(row) {
      const params = {
        jcnf: this.queryParams.jcnf,
        xmbh: row.xmbh,
        xmmc: row.xmmc,
        xmzt: row.xmzt,
        bmbh: row.bmbh,
      };
      sessionStorage.setItem("lineCheckDetailParams", JSON.stringify(params));
      // 本地调试使用
      // this.$router.push("/xmcheck/xsjmxList");

      // 测试生产使用
      var dataUrl = `/menuRedirect?systemType=tmis-pmp&redireType=tmis&menuType=78`;
      var menuName = `线上检明细列表`;
      var dataIndex = Math.round(Math.random() * 10000);

      var data = { dataIndex, dataUrl, menuName };
      window.parent.postMessage(data, "*");
    },
    handleToZbCheckDetail(row) {
      const params = {
        jcnf: this.queryParams.jcnf,
        xmbh: row.xmbh,
        xmmc: row.xmmc,
        xmzt: row.xmzt,
        bmbh: row.bmbh,
      };
      sessionStorage.setItem("zbCheckDetailParams", JSON.stringify(params));
      // 本地调试使用

      // this.$router.push("/xmcheck/zbxcjList");

      var dataUrl = `/menuRedirect?systemType=tmis-pmp&redireType=tmis&menuType=79`;
      var menuName = "总部现场检";
      var dataIndex = Math.round(Math.random() * 10000);
      var data = { dataIndex, dataUrl, menuName };
      window.parent.postMessage(data, "*");
    },
    handleToFzCheckDetail(row, jccs) {
      if (jccs === 2 && row && !row.fzjg1) {
        this.$message.error("首次检还未进行，请先进行首次检！");
        return;
      }

      const data = {
        jcnf: this.queryParams.jcnf,
        xmbh: row.xmbh,
        xmmc: row.xmmc,
        jccs: jccs + "",
        xmzt: row.xmzt,
        bmbh: row.bmbh,
      };
      sessionStorage.setItem("fzCheckDetailParams", JSON.stringify(data));
      // 本地调试使用
      // this.$router.push("/xmcheck/fzxsjList");

      //测试生产使用
      var dataUrl = `/menuRedirect?systemType=tmis-pmp&redireType=tmis&menuType=80`;
      var menuName = "分总现场检";
      var dataIndex = Math.round(Math.random() * 10000);
      var data1 = { dataIndex, dataUrl, menuName };
      window.parent.postMessage(data1, "*");
    },

    handleChangeHtzt(i) {
      this.queryParams.xmzt = i;
      this.getXmxxListFun();
    },
    handleToEdit(row, jccs) {
      if (jccs === 2 && !row.zbjg1) {
        this.$message.error("首次检还未进行，请先进行首次检！");
        return;
      }
      this.editDialog = true;
      this.editForm = { ...row, ...this.editFormbfdx };
      this.editForm.jccs = jccs;
      this.editForm.bfdx = {
        dsz: "",
        hz: "",
        fgld: "",
        qtbmfzr: "",
        qtgg: "",
      };
    },
    handleEditResult() {
      this.$refs["editForm"].validate((valid) => {
        if (valid) {
          const { bfdx } = this.editForm;
          let bfdxStr = "";
          let hasBfdx = false;
          if (bfdx.dsz) {
            bfdxStr += "1#" + bfdx.dsz + ",";
            hasBfdx = true;
          }
          if (bfdx.hz) {
            bfdxStr += "2#" + bfdx.hz + ",";
            hasBfdx = true;
          }
          if (bfdx.fgld) {
            bfdxStr += "3#" + bfdx.fgld + ",";
            hasBfdx = true;
          }
          if (bfdx.qtbmfzr) {
            bfdxStr += "4#" + bfdx.qtbmfzr + ",";
            hasBfdx = true;
          }
          if (bfdx.qtgg) {
            bfdxStr += "5#" + bfdx.qtgg + ",";
            hasBfdx = true;
          }
          if (!hasBfdx) {
            this.$message.error("请输入拜访对象！");
            return;
          }
          let { uploadFiles } = this.$refs.upload;
          let fileLen = uploadFiles.length;
          let form = new FormData();
          uploadFiles.forEach((item, index) => {
            form.append("files", item.raw);
          });

          if (fileLen > 0) {
            //上传文件
            this.fullscreenLoading = true;
            return new Promise((resolve, reject) => {
              uploadFile(form)
                .then((res) => {
                  if (res.code == 0) {
                    this.$message.success("上传成功！");
                  } else {
                    this.$message({
                      type: "error",
                      message: res.msg,
                      showClose: true,
                    });
                    this.fullscreenLoading = false;
                  }
                  resolve(res);
                })
                .catch((err) => {
                  reject(err);
                });
            }).then((success) => {
              if (success.code == 0) {
                this.editForm.fileIds = success.data;
                this.saveForm(bfdxStr);
              }
            });
          } else if (fileLen == 0) {
            this.$message.error("请上传巡检报告！");
          } else {
            this.$message.error(res.msg);
            return false;
          }
        }
      });
    },
    saveForm(bfdxStr) {
      const { xmbh, xjrq, xjjg, xjzz, xjcy, fgscy, jcnf, jccs, fileIds } =
        this.editForm;

      const params = {
        xmbh: xmbh,
        xjrq: moment(xjrq).format("YYYYMMDD"),
        xjjg,
        xjzz: xjzz.join(","),
        xjcy: xjcy.join(","),
        fgscy: fgscy.join(","),
        bfdx: bfdxStr,
        jcnf,
        jccs,
        fileIds,
        id: "",
      };
      console.log();
      saveZbInspect(params).then((res) => {
        if (res.code == 0) {
          this.getList();
          this.editDialog = false;
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg);
        }

        this.fullscreenLoading = false;
      });
    },
    handleChange(file, fileList) {
      //验证上传文件的格式;
      const suffixReg = /(xls|xlsx|pdf|doc|docx|rar|zip)$/;
      const point = file.name.lastIndexOf(".");
      const suffix = file.name.substr(point + 1);
      const isFile = suffixReg.test(suffix);
      if (!isFile) {
        this.$message.error("请上传正确格式的文件 !");
        fileList.pop();
        return false;
      }
      // 验证文件大小
      const isLt50M = file.size / 1024 / 1024 < 10;
      if (!isLt50M) {
        this.$message.error(file.name + "文件大小超出限制，请修改后重新上传");
        fileList.pop();
        return false;
      }
      // 验证上传文件重复;
      let existFile = fileList
        .slice(0, fileList.length - 1)
        .find((f) => f.name === file.name);
      if (existFile) {
        this.$message.error("当前文件已经存在!");
        fileList.pop();
        return false;
      }
    },
    handleExceed(files, fileList) {
      this.$message.error(
        `当前限制选择 5 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    handleChangeXm() {
      // setTimeout(() => {
      //   document.querySelector(
      //     "#xmxjList .xmmc .el-select__tags"
      //   ).scrollLeft = 0;
      // });
    },
  },
};
</script>
<style lang="less" scoped>
.app-container {
  padding: 10px;
  height: 100%;
  width: 100%;
  background-color: #fff;
  box-sizing: border-box;
  padding-bottom: 0;
}
.mycontainer {
  padding: 10px;
  background-color: #fff;
  border-radius: 6px;
  box-sizing: border-box;
  padding-bottom: 0;
}
.filter-container {
  padding: 0;
}
.search-container {
  border: 0;
}
::v-deep #dic-form .el-form-item {
  margin-bottom: 0;
}
.el-form-item {
  margin-bottom: 22px;
}
.bfdx {
  display: flex;
  flex-wrap: wrap;
  > div {
    width: 33%;
    display: flex;
    > span {
      width: 115px;
      text-align: right;
    }
  }
}
.treeselect {
  line-height: 21px;
}
.app-container {
  padding: 10px;
  .dialog-footer {
    text-align: right;
    button {
      margin-left: 30px;
    }
  }
}
.mycontainer .el-form-item {
  margin-bottom: 5px;
}
</style>
